import Comp from './index';

export default Comp({ newComp: false });
